import React from "react"
import "./ugSlider.scss"
import Slick from "react-slick"
import Pagination from "./pagination"
import Img from "./img"
import {Row, Col} from 'antd'
import "./teacherSlider.scss"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const teachers = [{
    name: "靳浩",
    subtitle: "资深设计讲师",
    desc: <div>
        深圳像素范儿创始人<br/>
        站酷高高手在线教育网合作UI讲师<br/>
        线下班面授学员1000+人<br/>
        学员作品多次获得国际设计网站Behance和国内设计网站ZCOOL网推荐<br/>
        学员遍布阿里、腾讯、百度、滴滴等一线互联网公司<br/>
    </div>
    ,
    showSrc: "https://img.uigreat.com/szpxfer/jinhao.png",
    courseLink: "https://uigreat.com/course/30"
}, {
    name: "邹子轩",
    subtitle: "高级讲师",
    desc: <div>
        深圳像素范儿联合创始人<br/>
        前飞米科技UI高级设计师<br/>
        负责小米无人机、手机手持云台、运动小相机、米兔小飞机<br/>等硬件类产品设计<br/>
        耕耘像素范儿深圳圈子一年之久，在北京的创业合作伙伴<br/>包括高德、美团、滴滴等
    </div>,
    showSrc: "https://img.uigreat.com/szpxfer/zhouzixuan.png",
    courseLink: ""
}, {
    name: "朱世民",
    subtitle: "高级讲师",
    desc: <div>
        丰富的互联网从业经验，助攻视觉设计，交互设计<br/>
        丰富的一线2C和2B产品经验，服务过多家知名公司，腾讯、宝马<br/>
        共享汽车、跨越速运集团等<br/>
        独立研发UI设计教程，获学生高度认可，提升学生能力<br/>
        善于激发学生思维，有独特授课技巧<br/>
    </div>,
    showSrc: "https://img.uigreat.com/szpxfer/zhushimin.png",
    courseLink: "https://uigreat.com/course/49"
}]


class TeacherSlider extends React.Component {
    constructor(props) {
        super(props)
        this.sliderRef = React.createRef()
    }

    state = {
        current: 1,
        changeStatus: 0,
    }

    render() {
        return (
            <div className={`teacher-slider`} data-sal="slide-up" data-sal-delay="100" data-sal-duration="1000"
                 data-sal-easing="ease">
                <Row type="flex" align="bottom">
                    <Col xs={24} md={12} className={`col-left`}>
                        <div className={`teacher-intro`} data-sal="slide-up">
                            <div
                                className={`${this.state.changeStatus === 1 ? "change-before" : this.state.changeStatus === 2 ? "change-after" : ""}`}>
                                <div className={`name`}>{teachers[this.state.current - 1].name}<span
                                    className={`subtitle`}>({teachers[this.state.current - 1].subtitle})</span></div>
                                <div className={`desc`}>
                                    {teachers[this.state.current - 1].desc}
                                </div>
                            </div>
                        </div>
                        <div className="teacher-class-link" hidden={!teachers[this.state.current - 1].courseLink}
                             onClick={() => {
                                 if (teachers[this.state.current - 1].courseLink) {
                                     window.open(teachers[this.state.current - 1].courseLink)
                                 }
                             }}>
                            <Img src={"https://img.uigreat.com/szpxfer/play.png"}/>讲师公开课
                        </div>
                        <Pagination className={`teacher-pagination `} current={this.state.current || 1}
                                    total={teachers.length || 0} onNext={() => {
                            this.sliderRef.current.slickNext()
                        }} onPrev={() => {
                            this.sliderRef.current.slickPrev()
                        }}/>
                    </Col>
                    <Col xs={24} md={12} className={`col-right`}>
                        <div className="slick-outter">
                            <Slick className={`slider`}
                                   dots={false}
                                   infinite={true}
                                   speed={500}
                                   slidesToScroll={1}
                                   slidesToShow={1}
                                // initialSlide={0}
                                   arrows={false}
                                   variableWidth={false}
                                   ref={this.sliderRef}
                                   centerMode={true}
                                   centerPadding={0}
                                // adaptiveHeight={true}
                                   beforeChange={(oldCurrent, current) => {
                                       this.setState({
                                           changeStatus: 1
                                       })
                                   }}
                                   afterChange={current => {
                                       this.setState({
                                           current: current + 1,
                                           changeStatus: 2
                                       })
                                   }}
                            >
                                {
                                    teachers.map((item, index) =>
                                        <div className={`slider-item slider-item-${index}`} key={index}>
                                            <div className={`teacher-item`}>
                                                <Img className={`teacher-show`} src={item.showSrc} draggable={false}
                                                     alt={""}/>
                                            </div>
                                        </div>
                                    )
                                }
                            </Slick>
                        </div>
                    </Col>
                </Row>
            </div>

        )
    }
}

export default TeacherSlider
